export default "__VITE_ASSET__CwgXxa3i__"